<template>
    <div>
        <content-page :page="page" :loading="loading" />
        <slot v-if="!isAuthed" name="footer" />
    </div>
</template>

<script>
import createContentPageView from '@/helpers/content-page-route'

export default {
    ...createContentPageView('about'),
};
</script>
